import { Component, inject, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SurveyCategoriesConst } from '@shared/consts';
import { QuestionTypesEnum } from '@shared/enums';
import { IAnswer, IQuestion, ISurvey } from '@shared/models/survey.interfaces';
import { RequestsService } from '@shared/providers/external/requests.service';

@Component({
    selector: 'anp-survey',
    templateUrl: './survey.component.html',
    styleUrls: ['./survey.component.scss'],
    standalone: false
})
export class SurveyComponent implements OnInit {
  /**DEPENDENCIES */
  private readonly requestsService = inject(RequestsService);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() public survey: ISurvey;
  public questionType = QuestionTypesEnum;
  public completed: boolean;

  constructor(private modalCtrl: ModalController) {
  }
  ngOnInit(): void {
    this.requestsService.getSurveyById(this.survey.Id).then((survey) => {
      this.survey.Questions = survey;
      this.validateSurvey();
    }).catch((error) => {
      console.error('Error fetching survey by ID:', error);
    });
  }

  public get surveyCategory(): string {
    const category = SurveyCategoriesConst.find((cat) => cat.id === this.survey.Type);
    return (category && category.label) ?? 'General';
  }

  public async dismiss(completed?: boolean): Promise<void> {
    await this.modalCtrl.dismiss({ completed: !!completed, survey: this.survey });
  }

  public onCompleted(): void {
    this.survey.Completed = true;
    this.completed = true;
    this.dismiss(this.completed);
  }

  /**
   * @description cuando una respuesta de seleccion multiple es seleccionada o deseleccionada,
   * actualiza el estado de la encuesta
   * @param answer
   */
  public onMultipleChoiceOptionChange(event, answer: IAnswer, questionIndex: number) {
    const { checked } = event.target;
    const question = { ...this.survey.Questions[questionIndex] };
    let selectedAnswers = question.Selected ?? [];
    if (checked) selectedAnswers.push(answer);
    if (!checked) selectedAnswers = selectedAnswers.filter((selAnswer) => selAnswer.Id !== answer.Id);
    question.Selected = selectedAnswers;
    this.survey.Questions[questionIndex] = question;
    this.validateSurvey();
  }

  /**
   * @description cuando se cambia el valor de una pregunta abierta
   * actualiza el estado de la encuesta
   * @param answer
   */
  public onOpenQuestionChange(event, questionIndex: number) {
    const { value } = event.target;
    this.survey.Questions[questionIndex].Comment = value;
    this.validateSurvey();
  }

  /**
   * @description cuando una respuesta de seleccion unica es seleccionada
   * actualiza el estado de la encuesta
   * @param answer
   */
  public onSingleChoiceOptionChange(event, questionIndex: number) {
    const { value } = event.target;
    const question = { ...this.survey.Questions[questionIndex] };
    question.Selected = [value];
    this.survey.Questions[questionIndex] = question;
    this.validateSurvey();
  }

  private validateSurvey() {
    const questions: IQuestion[] = this.survey.Questions;
    /**
     * * Verifica que la pregunta tenga una seleccion (se ignoran las preguntas abiertas)
     */
    const questionChecker = (question: IQuestion) =>
      (question.Selected && question.Selected.length > 0) || question.Type === 2;
    this.completed = questions.every((question) => questionChecker(question));
  }
}
